import LanguageTableHelper from "./language-table-helper";
import LanguageOptionsHelper from "./language-options-helper";


const LanguageHelpers = {
    TableMain: LanguageTableHelper,
    Options: LanguageOptionsHelper,
};

export default LanguageHelpers;
